import { Component } from '@angular/core';

@Component({
    selector: 'prompt-admin',
    templateUrl: 'promptAdmin.component.html',
    styleUrls: ['promptAdmin.component.css'],
    standalone: false
})
export class PromptAdminComponent {
}
